export type Marketplace = "amazon" | "magalu" | "mercado-livre" | "outros";

export type Deal = {
  id: string;
  title: string;
  image: string;
  price?: number; // current price (optional when unknown)
  bestPrice?: number; // historical best
  category: string;
  marketplace: Marketplace;
  affiliateUrl: string;
  discoveredAt: string; // ISO date
  tags?: string[];
  brand?: string;
  description?: string;
  productUrl?: string; // full product page URL (used to resolve images)
};

export const ALL_CATEGORIES: string[] = [
  "Cafés",
  "Alimentos Saudáveis",
  "Utensílios de cozinha",
];

export const ALL_MARKETPLACES: Marketplace[] = ["amazon"];

function getAmazonTag() {
  // Configure sua tag de afiliado no arquivo .env como VITE_AMAZON_TAG
  // ex: VITE_AMAZON_TAG=seu-id-20
  return (import.meta as any).env?.VITE_AMAZON_TAG || "";
}

export function withAmazonAffiliate(url: string) {
  const tag = getAmazonTag();
  if (!tag) return url;
  const hasQuery = url.includes("?");
  const sep = hasQuery ? "&" : "?";
  // Amazon BR usa parâmetro 'tag'
  return `${url}${sep}tag=${encodeURIComponent(tag)}`;
}

export const deals: Deal[] = [
  // Cafés
  {
    id: "cafes-1",
    title: "Cafés – Seleção 1",
    image: "/placeholder.svg",
    category: "Cafés",
    marketplace: "amazon",
    affiliateUrl: "https://amzn.to/4oEjpWT",
    productUrl: "https://www.amazon.com.br/Caf%C3%A9-Gourmet-Gr%C3%A3o-Santa-Monica/dp/B01C5WCNPA?ref_=Oct_d_omg_d_19778175011_4&pd_rd_w=pnZCG&content-id=amzn1.sym.78a0facb-6f56-4c0e-83c7-7b40b9427a01&pf_rd_p=78a0facb-6f56-4c0e-83c7-7b40b9427a01&pf_rd_r=5EPD8JWEMM5H35DAK1FS&pd_rd_wg=2UeoV&pd_rd_r=945baa6b-af10-4b0a-a40e-f4af3a8fba78&pd_rd_i=B01C5WCNPA",
    discoveredAt: new Date().toISOString(),
    tags: ["café", "bebidas"],
  },
  {
    id: "cafes-2",
    title: "Cafés – Seleção 2",
    image: "/placeholder.svg",
    category: "Cafés",
    marketplace: "amazon",
    affiliateUrl: "https://amzn.to/4msZAjW",
    discoveredAt: new Date(Date.now() - 1000*60*60*6).toISOString(),
    tags: ["café"],
  },
  {
    id: "cafes-3",
    title: "Cafés – Seleção 3",
    image: "/placeholder.svg",
    category: "Cafés",
    marketplace: "amazon",
    affiliateUrl: "https://amzn.to/4mMPmKT",
    discoveredAt: new Date(Date.now() - 1000*60*60*12).toISOString(),
  },
  {
    id: "cafes-4",
    title: "Cafés – Seleção 4",
    image: "/placeholder.svg",
    category: "Cafés",
    marketplace: "amazon",
    affiliateUrl: "https://amzn.to/4oEro6h",
    discoveredAt: new Date(Date.now() - 1000*60*60*18).toISOString(),
  },
  // Alimentos Saudáveis
  {
    id: "saudaveis-1",
    title: "Alimentos Saudáveis – Seleção 1",
    image: "/placeholder.svg",
    category: "Alimentos Saudáveis",
    marketplace: "amazon",
    affiliateUrl: "https://amzn.to/4fF8Y13",
    discoveredAt: new Date(Date.now() - 1000*60*60*24).toISOString(),
  },
  {
    id: "saudaveis-2",
    title: "Alimentos Saudáveis – Seleção 2",
    image: "/placeholder.svg",
    category: "Alimentos Saudáveis",
    marketplace: "amazon",
    affiliateUrl: "https://amzn.to/45kdYoo",
    discoveredAt: new Date(Date.now() - 1000*60*60*30).toISOString(),
  },
  {
    id: "saudaveis-3",
    title: "Alimentos Saudáveis – Seleção 3",
    image: "/placeholder.svg",
    category: "Alimentos Saudáveis",
    marketplace: "amazon",
    affiliateUrl: "https://amzn.to/4oFZhnc",
    discoveredAt: new Date(Date.now() - 1000*60*60*36).toISOString(),
  },
  {
    id: "saudaveis-4",
    title: "Alimentos Saudáveis – Seleção 4",
    image: "/placeholder.svg",
    category: "Alimentos Saudáveis",
    marketplace: "amazon",
    affiliateUrl: "https://amzn.to/45Rzp0a",
    discoveredAt: new Date(Date.now() - 1000*60*60*42).toISOString(),
  },
  // Utensílios de cozinha
  {
    id: "utensilios-1",
    title: "Utensílios de cozinha – Seleção 1",
    image: "/placeholder.svg",
    category: "Utensílios de cozinha",
    marketplace: "amazon",
    affiliateUrl: "https://amzn.to/45SGqhf",
    discoveredAt: new Date(Date.now() - 1000*60*60*48).toISOString(),
  },
  {
    id: "utensilios-2",
    title: "Utensílios de cozinha – Seleção 2",
    image: "/placeholder.svg",
    category: "Utensílios de cozinha",
    marketplace: "amazon",
    affiliateUrl: "https://amzn.to/4oEiDZZ",
    discoveredAt: new Date(Date.now() - 1000*60*60*54).toISOString(),
  },
];
